import { useQuery } from "react-query";
import axios from "infra/http";

function useNaturezaJuridicas() {
  return useQuery(
    "/v1/natureza-juridica",
    async (): Promise<{ nome: string; id: string }[]> => {
      const res = await axios.get("/v1/natureza-juridica");

      return res.data;
    }
  );
}

export default useNaturezaJuridicas;
